module.exports = __webpack_public_path__ + "img/medical researchHeader.cf9f790e.png";